import React from 'react';
import { TextInput } from 'lego-on-react';
import * as keyset from 'i18n/AliceSkillForm';
import i18n from '@yandex-int/i18n';
import { Field, Header } from '../Form/Form';
import { AliceSkillFormSettings } from '../../types';
import { FormChangeHandler } from '../../hocs/types';
import Link from '../Link/Link';
import { routes } from '../../lib/routes';
import { DevPreviewBanner } from '../DocumentationPage/DevPreviewBanner';
import Description from '../Form/Description/Description';
import { wrapInText } from '../../lib/i18n-utils';

const t = i18n(keyset);

interface Props {
    values: AliceSkillFormSettings;
    onChange: FormChangeHandler<AliceSkillFormSettings>;
    disabled?: boolean;
}

const description = (
    <Description>
        {wrapInText(
            (s) => <Link to="https://appmetrica.yandex.ru/docs/">{s}</Link>,
            (s) => <Link to={routes.documentation.aliceSkills.appmetrica}>{s}</Link>,
        )(t('app-metrica-description'))}
    </Description>
);

export const AppMetricaSettings: React.FC<Props> = ({ onChange, values, disabled }) => {
    return (
        <>
            <Header
                subtitle={
                    __appConfig.app.displayDevPreviewWarnings && (
                        <div style={{ fontSize: '13px' }}>
                            <DevPreviewBanner />
                        </div>
                    )
                }
            >
                Настройки AppMetrica
            </Header>
            <Field label={t('label-api-key')} description={description}>
                <TextInput
                    theme="normal"
                    size="s"
                    text={values.appMetricaApiKey}
                    onChange={onChange('appMetricaApiKey')}
                    disabled={disabled}
                />
            </Field>
        </>
    );
};
